export default "__VITE_ASSET__IzSEVv1M__"